module.exports = __webpack_public_path__ + "static/media/lv_call_fake.d16ecbf1.mp3";